'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIForm;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _DomEvents = require('../utils/DomEvents');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIForm(props) {
  var action = props.action,
      className = props.className,
      _onKeyDown = props.onKeyDown,
      onSubmit = props.onSubmit,
      rest = _objectWithoutProperties(props, ['action', 'className', 'onKeyDown', 'onSubmit']);

  return (
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    _react2.default.createElement('form', _extends({}, rest, {
      className: (0, _classnames2.default)('private-form', className),
      action: action,
      onKeyDown: function onKeyDown(evt) {
        // Submit on Cmd+Enter or Ctrl+Enter (avoiding double-submit from an <input>: #4578)
        var inputFocused = document.activeElement instanceof HTMLInputElement;
        if (evt.key === 'Enter') {
          if (evt.metaKey || evt.ctrlKey && !inputFocused) {
            if (onSubmit) onSubmit((0, _SyntheticEvent2.default)());
          }
        }
        if (_onKeyDown) _onKeyDown(evt);
      },
      onSubmit: !action && !onSubmit ? _DomEvents.preventDefaultHandler : onSubmit
    }))
    /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */

  );
}

UIForm.propTypes = {
  action: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired,
  onSubmit: _propTypes2.default.func
};

UIForm.displayName = 'UIForm';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/form/UIForm.js
// module id = 572
// module chunks = 177